import React, {useState} from 'react'
import languages, {loadLocaleFile, languageLocalStorageKey} from '../languages'

import './style.scss';
import carrot from '../images/ic_carrot.svg';
import globe from '../images/ic_globe.svg';

export default function LanguageDropdown(props) {
  const [temporaryValue, setTemporaryValue] = useState(null)
  const { language, setLanguage } = props
  const requestLanguage = (event) => {
    const newLanguage = event.target.value
    loadLocaleFile(newLanguage).then(() => {
      setTemporaryValue(null)
      window.localStorage.setItem(languageLocalStorageKey, newLanguage)
      setLanguage(newLanguage)
    })
  }
  const languagesSorted = [...languages]
  languagesSorted.sort((a, b) => {
    return a.translated.toLowerCase().localeCompare(b.translated.toLowerCase());
  })
  return (
    <div className='dropdownContainer'>
      <select
        value={temporaryValue || language}
        onChange={requestLanguage}
      >
        {languagesSorted.map(language =>
          <option key={language.code} value={language.code}>
            {language.translated}
          </option>
        )}
      </select>
      <div className='image left'>
        <img src={globe} alt='' />
      </div>
      <div className='image right'>
        <img src={carrot} alt='' />
      </div>
      <div className='note'>
        Translated by Google
      </div>
    </div>
  )
}